export const json = {
  "Please enter your Eircode or check the box": {
    eng: "Please enter your Eircode or check the box",
    lt: "Prašome įvesti Eircode arba pažymėti langelį"
  },
  "SAVE {{amount}}": {
    eng: "SAVE {{amount}}",
    lt: "Sutaupote {{amount}}"
  },
  "Your Cart": {
    eng: "Your Cart",
    lt: "Jūsų krepšelis"
  },
  Services: {
    eng: "Services",
    lt: "Paslaugos"
  },
  Price: {
    eng: "Price",
    lt: "Kaina"
  },
  Quantity: {
    eng: "Quantity",
    lt: "Kiekis"
  },
  "Total Price": {
    eng: "Total Price",
    lt: "Viso"
  },
  "Total: {{amount}}": {
    eng: "Total: {{amount}}",
    lt: "Viso: {{amount}}"
  },
  "You saved: {{amount}}": {
    eng: "You saved: {{amount}}",
    lt: "Sutaupėte: {{amount}}"
  },
  "Loading...": {
    eng: "Loading...",
    lt: "Įkeliama..."
  },
  "Based on your choices, here are some special offers with a discount": {
    eng: "Based on your choices, here are some special offers with a discount",
    lt: "Sprendžiant iš Jūsų pasirinkimo, galbūt sudomins šie pasūlymai su nuolaida"
  },
  "Show description": {
    eng: "Show description",
    lt: "Rodyti aprašymą"
  },
  "ADD TO CART": {
    eng: "ADD TO CART",
    lt: "Į KREPŠELĮ"
  },
  ADDED: {
    eng: "ADDED",
    lt: "ĮDĖTA"
  },
  Checkout: {
    eng: "Checkout",
    lt: "Apmokėjimas"
  },
  "Thank you for your booking! Details have been emailed to you.": {
    eng: "Thank you for your booking! Details have been emailed to you.",
    lt: "Ačiū, užsakymas pateiktas! Patvirtinimą išsiuntėme Jums el. paštu."
  },
  "Please select a different date for your cleaning. The selected date is no longer available":
    {
      eng: "Please select a different date for your cleaning. The selected date is no longer available",
      lt: "Ši diena nebegalima. Prašome pasirinkti kitą datą."
    },
  Back: {
    eng: "Back",
    lt: "Atgal"
  },
  "Next Step": {
    eng: "Next Step",
    lt: "Toliau"
  },
  "All Services": {
    eng: "All Services",
    lt: "Visos paslaugos"
  },
  "Page not found": {
    eng: "Page not found",
    lt: "Puslapis nerastas"
  },
  "The link you followed may be broken, or the page may have been removed.": {
    eng: "The link you followed may be broken, or the page may have been removed.",
    lt: "Ši nuoroda neveikia arba puslapis pašalintas."
  },
  Name: {
    eng: "Name",
    lt: "Vardas"
  },
  "Please enter your first name": {
    eng: "Please enter your first name",
    lt: "Įveskite vardą"
  },
  "Please enter your last name": {
    eng: "Please enter your last name",
    lt: "Įveskite pavardę"
  },
  "Please enter your first name and your last name": {
    eng: "Please enter your first name and your last name",
    lt: "Įveskite vardą ir pavardę"
  },
  "Please enter your email": {
    eng: "Please enter your email",
    lt: "Įveskite el. paštą"
  },
  "Please enter a valid email": {
    eng: "Please enter a valid email",
    lt: ""
  },
  "Please enter a valid phone number": {
    eng: "Please enter a valid phone number",
    lt: "Įveskite teisingą telefono numerį"
  },
  "Please enter your phone number": {
    eng: "Please enter your phone number",
    lt: "Įveskite savo tel. nr."
  },
  "Email is blacklisted": {
    eng: "Email is blacklisted",
    lt: "El. paštas įtrauktas į juodąjį sąrašą"
  },
  "Please provide your details in the form below to proceed.": {
    eng: "Please provide your details in the form below to proceed.",
    lt: "Įveskite savo duomenis žemiau esančioje formoje."
  },
  Email: {
    eng: "Email",
    lt: "El. paštas"
  },
  "Repeat email": {
    eng: "Repeat email",
    lt: "Pakartokite el. paštą"
  },
  "Phone Number": {
    eng: "Phone Number",
    lt: "Tel. nr."
  },
  Address: {
    eng: "Address",
    lt: "Adresas"
  },
  "By proceeding with your booking you agree to our {{Terms of service}} and {{Privacy Policy}}. We may occasionally send you newsletters with special offers. Don’t worry, you can easily unsubscribe at anytime.":
    {
      eng: "By proceeding with your booking you agree to our {{Terms of service}} and {{Privacy Policy}}. We may occasionally send you newsletters with special offers. Don’t worry, you can easily unsubscribe at anytime.",
      lt: "Tęsdami sutinkate su mūsų {{Terms of service}} ir {{Privacy Policy}}. Kartais Jums atsiųsime naujienlaiškių su ypatingais pasiūlymais, tačiau visuomet galėsite jų atsisakyti."
    },
  "Terms of service": {
    eng: "Terms of service",
    lt: "Taisyklėmis "
  },
  "Privacy Policy": {
    eng: "Privacy Policy",
    lt: "Privatumo politika"
  },
  "Notes (optional)": {
    eng: "Notes (optional)",
    lt: "Pastabos (nebūtina)"
  },
  "You have chosen {{date}} for your cleaning from {{start_time}} to {{end_time}}":
    {
      eng: "You have chosen {{date}} for your cleaning from {{start_time}} to {{end_time}}",
      lt: "Valymui pasirinkote {{date}} nuo {{start_time}} iki {{end_time}}"
    },
  "Based on your picks, here are some extra services you might want to consider":
    {
      eng: "Based on your picks, here are some extra services you might want to consider",
      lt: "Prie Jūsų pasirinktų paslaugų gali praversti šie priedai"
    },
  "Please add {{amount}} more to place your order. Minimum total is {{amount}}":
    {
      eng: "Please add {{amount}} more to place your order. Minimum total is {{amount}}",
      lt: "Kad galėtumėte pateikti užsakymą, įsidėkite paslaugų už dar {{amount}}, nes minimali suma yra {{amount}}."
    },
  "1. Cart": {
    eng: "1. Cart",
    lt: "1. Krepšelis"
  },
  "2. Extras": {
    eng: "2. Extras",
    lt: "2. Priedai"
  },
  "3. Time": {
    eng: "3. Time",
    lt: "3. Laikas"
  },
  "4. Address": {
    eng: "4. Address",
    lt: "4. Adresas"
  },
  "5. Payment": {
    eng: "5. Payment",
    lt: "5. Apmokėjimas"
  },
  "Over 33 000 satisfied customers": {
    eng: "Over 33 000 satisfied customers",
    lt: "Virš 40 tūkst. klientų Airijoje"
  },
  "Guaranteed cleaning until satisfaction": {
    eng: "Guaranteed cleaning until satisfaction",
    lt: "Valome tol, kol tiks"
  },
  "Show order summary": {
    eng: "Show order summary",
    lt: "Rodyti užsakymo santrauką"
  },
  "Have a discount code?": {
    eng: "Have a discount code?",
    lt: "Turite kuponą?"
  },
  Apply: {
    eng: "Apply",
    lt: "Pritaikyti"
  },
  Subtotal: {
    eng: "Subtotal",
    lt: "Tarpinė suma"
  },
  "You save": {
    eng: "You save",
    lt: "Sutaupote"
  },
  Coupon: {
    eng: "Coupon",
    lt: "Kuponas"
  },
  Total: {
    eng: "Total",
    lt: "Iš viso"
  },
  "This coupon is not applicable.": {
    eng: "This coupon is not applicable.",
    lt: "Kuponas neveikia."
  },
  "Confirm the order for free": {
    eng: "Confirm the order for free",
    lt: "Patvirtinti nemokamą užsakymą"
  },
  "Could not confirm the order": {
    eng: "Could not confirm the order",
    lt: "Užsakymo patvirtinti nepavyko"
  },
  Confirm: {
    eng: "Confirm",
    lt: "Patvirtinti"
  },
  Pay: {
    eng: "Pay",
    lt: "Mokėti"
  },
  "Copy my cart link for someone else to pay": {
    eng: "Copy my cart link for someone else to pay",
    lt: "Nukopijuoti krepšelio nuorodą, kad apmokėtų kitas asmuo"
  },
  "Copy my cart link for someone else to complete": {
    eng: "Copy my cart link for someone else to complete",
    lt: "Nukopijuokite mano krepšelio nuorodą, kad jį užpildytų kažkas kitas"
  },
  "This payment link is no longer valid or the booking has been edited/cancelled.": {
    eng: "This payment link is no longer valid or the booking has been edited/cancelled.",
    lt: "Ši mokėjimo nuoroda nebegalioja arba užsakymas buvo pakeistas / atšauktas."
  },
  "Return to Home": {
    eng: "Return to Home",
    lt: "Grįžti į pradžią"
  },
  Copied: {
    eng: "Copied",
    lt: "Nukopijuota"
  },
  "Book with confidence: you can reschedule for free up to 24 hours before your scheduled appointment.":
    {
      eng: "Book with confidence: you can reschedule for free up to 24 hours before your scheduled appointment.",
      lt: "Nesijaudinkite, visuomet galėsite pakeisti datą likus ne mažiau kaip 24 val. iki užsakymo."
    },
  "Payment Type": {
    eng: "Payment Type",
    lt: "Mokėjimo būdas"
  },
  "Only pay a deposit of {{amount}}. The rest can be paid in cash or card to the cleaner.":
    {
      eng: "Only pay a deposit of {{amount}}. The rest can be paid in cash or card to the cleaner.",
      lt: "Mokėti tik {{amount}} užstatą, o likusią sumą grynaisiais arba kortele valytojui."
    },
  "Payment Method": {
    eng: "Payment Method",
    lt: "Mokėjimo būdas"
  },
  "Card Number": {
    eng: "Card Number",
    lt: "Kortelės nr."
  },
  "Payment is processing.": {
    eng: "Payment is processing.",
    lt: "Mokėjimas vykdomas."
  },
  "A message will be sent to the customer's email address once the payment is successful":
    {
      eng: "A message will be sent to the customer's email address once the payment is successful",
      lt: "Mokėjimui pavykus, kliento el. paštu bus nusiųsta žinutė"
    },
  "Payment failed": {
    eng: "Payment failed",
    lt: "Mokėjimas nepavyko"
  },
  "Please select a date and time for your cleaning": {
    eng: "Please select a date and time for your cleaning",
    lt: "Pasirinkite norimą dieną ir laiką"
  },
  "Please select a time for your cleaning": {
    eng: "Please select a time for your cleaning",
    lt: "Pasirinkite norimą laiką"
  },
  "Address is blacklisted": {
    eng: "Address is blacklisted",
    lt: "Adresas įtrauktas į juodąjį sąrašą"
  },
  "Please choose a time slot by clicking on it.": {
    eng: "Please choose a time slot by clicking on it.",
    lt: "Pasirinkite laiką paspausdami ant jo."
  },
  "Please start entering your address and select one from the suggestions list.":
    {
      eng: "Please start entering your address and select one from the suggestions list.",
      lt: "Veskite savo adresą ir pasirinkite iš iššokančių siūlymų."
    },
  "Enter your address…": {
    eng: "Enter your address…",
    lt: "Įveskite adresą..."
  },
  "Selected Cleaner": {
    eng: "Selected Cleaner",
    lt: "Pasirinktas valytojas"
  },
  "No selected Cleaner": {
    eng: "No selected Cleaner",
    lt: "Valytojas nepasirinktas"
  },
  Any: {
    eng: "Any",
    lt: "Bet kuris"
  },
  "Have a favorite cleaner?": {
    eng: "Have a favorite cleaner?",
    lt: "Turite mėgstamą valytoją?"
  },
  "There is no cleaner available.": {
    eng: "There is no cleaner available.",
    lt: "Nėra laisvo valytojo."
  },
  "This cleaner is not available on this day.": {
    eng: "This cleaner is not available on this day.",
    lt: "Valytojas šią dieną užimtas."
  },
  "Please select a cleaner": {
    eng: "Please select a cleaner",
    lt: "Prašome pasirinkti valytoją"
  },
  Jan: {
    eng: "Jan",
    lt: "Sau"
  },
  Feb: {
    eng: "Feb",
    lt: "Vas"
  },
  Mar: {
    eng: "Mar",
    lt: "Kov"
  },
  Apr: {
    eng: "Apr",
    lt: "Bal"
  },
  May: {
    eng: "May",
    lt: "Geg"
  },
  Jun: {
    eng: "Jun",
    lt: "Bir"
  },
  Jul: {
    eng: "Jul",
    lt: "Lie"
  },
  Aug: {
    eng: "Aug",
    lt: "Rugp"
  },
  Sep: {
    eng: "Sep",
    lt: "Rugs"
  },
  Oct: {
    eng: "Oct",
    lt: "Spa"
  },
  Nov: {
    eng: "Nov",
    lt: "Lap"
  },
  Dec: {
    eng: "Dec",
    lt: "Gru"
  },
  Sun: {
    eng: "Sun",
    lt: "Sek"
  },
  Mon: {
    eng: "Mon",
    lt: "Pir"
  },
  Tue: {
    eng: "Tue",
    lt: "Ant"
  },
  Wed: {
    eng: "Wed",
    lt: "Tre"
  },
  Thur: {
    eng: "Thur",
    lt: "Ket"
  },
  Fri: {
    eng: "Fri",
    lt: "Pen"
  },
  Sat: {
    eng: "Sat",
    lt: "Šeš"
  },
  "We work with the environment in mind.": {
    eng: "We work with the environment in mind.",
    lt: "Dirbame galvodami apie gamtą."
  },
  "Our products have the Bioquest Formula™. They are biodegradable and dermatologically-tested to be allergy-free. They’re also certified by A.I.S.E":
    {
      eng: "Our products have the Bioquest Formula™. They are biodegradable and dermatologically-tested to be allergy-free. They’re also certified by A.I.S.E",
      lt: "Mūsų naudojamos priemonės turi Bioquest Formula™. Jos biologiškai suyra, nesukelia alergijos bei turi A.I.S.E sertifikatą."
    },
  "About us": { eng: "About us", lt: "Apie mus" },
  "About us Link": { eng: "About us", lt: "apie-mus" },
  Support: { eng: "Support", lt: "Parama" },
  "Support Link": { eng: "", lt: "parama-ukrainai" },
  Rules: { eng: "Rules", lt: "Taisyklės" },
  "Our locations": { eng: "Our locations", lt: "Vietos" },
  "Cleaners' corner": { eng: "Cleaners' corner", lt: "Valytojų kampelis" },
  "Terms and Conditions": {
    eng: "Terms and Conditions",
    lt: "Taisyklės"
  },
  "Staff corner": {
    eng: "Staff corner",
    lt: "Darbuotojų kampelis"
  },
  "Services and Pricelist": {
    eng: "Services and Pricelist",
    lt: "Paslaugos ir kainos"
  },
  "Before & After": {
    eng: "Before & After",
    lt: "Prieš ir po"
  },
  "Before & After Link": {
    eng: "new-before-after",
    lt: "pries-ir-po"
  },
  Commercial: {
    eng: "Commercial",
    lt: "Verslui"
  },
  Careers: {
    eng: "Careers",
    lt: "Karjera"
  },
  Help: {
    eng: "Help",
    lt: "Pagalba"
  },
  "Help Link": {
    eng: "contact",
    lt: "kontaktai"
  },
  remove: {
    eng: "remove",
    lt: "pašalinti"
  },
  "Proceed to Cart": {
    eng: "Proceed to Cart",
    lt: "Eiti į krepšelį"
  },
  "Booking #{{booking_id}}": {
    eng: "Booking #{{booking_id}}",
    lt: "Užsakymas #{{booking_id}}"
  },
  "Thank you for choosing us!": {
    eng: "Thank you for choosing us!",
    lt: "Ačiū, kad pasirinkote mus!"
  },
  "How would you rate our services?": {
    eng: "How would you rate our services?",
    lt: "Kaip mus įverintumėte?"
  },
  "Submit feedback": {
    eng: "Submit feedback",
    lt: "Siųsti vertinimą"
  },
  "Could not confirm rating": {
    eng: "Could not confirm rating",
    lt: "Vertinimo patvirtinti nepavyko"
  },
  "An error was encountered while trying to confirm your rating. If this persists, kindly contact us.":
    {
      eng: "An error was encountered while trying to confirm your rating. If this persists, kindly contact us.",
      lt: "Tvirtinant vertinimą kilo klaida. Jei ji kartojasi, prašome su mumis susisiekti."
    },
  "Thank you for helping us improve!": {
    eng: "Thank you for helping us improve!",
    lt: "Ačiū, kad padedate mums tobulėti!"
  },
  "We cannot take your rating.": {
    eng: "We cannot take your rating.",
    lt: "Jūsų vertinimo priimti nepavyko."
  },
  "Your feedback was submitted successfully": {
    eng: "Your feedback was submitted successfully",
    lt: "Jūsų vertinimą gavome."
  },
  "You have already rated this booking": {
    eng: "You have already rated this booking",
    lt: "Šį užsakymą jau įvertinote."
  },
  "{{number}} reviews": {
    eng: "{{number}} reviews",
    lt: "{{number}} atsiliepimų"
  },
  "1 review": {
    eng: "1 review",
    lt: "1 atsiliepimas"
  },
  "REVIEWS FOR {{service_name}}": {
    eng: "REVIEWS FOR {{service_name}}",
    lt: "ATSILIEPIMAI APIE {{service_name}}"
  },
  comments: {
    eng: "comments",
    lt: "komentarų"
  },
  "1 comment": {
    eng: "1 comment",
    lt: "1 komentaras"
  },
  Anonymous: {
    eng: "Anonymous",
    lt: "Anonimas"
  },
  hours: {
    eng: "hours",
    lt: "val."
  },
  "1 hour": {
    eng: "1 hour",
    lt: "1 valanda"
  },
  minutes: {
    eng: "minutes",
    lt: "min."
  },
  "1 minute": {
    eng: "1 minute",
    lt: "1 minutė"
  },
  "Bookings can be rescheduled no later than {{time}} before the cleaning takes place.":
    {
      eng: "Bookings can be rescheduled no later than {{time}} before the cleaning takes place.",
      lt: "Užsakymus galima perkelti ne vėliau kaip {{time}} iki suplanuoto valymo."
    },
  "Successfully rescheduled to {{time}}": {
    eng: "Successfully rescheduled to {{time}}",
    lt: "Perkelta į {{time}}"
  },
  "Thanks again for your patronage": {
    eng: "Thanks again for your patronage",
    lt: "Darsyk ačiū už Jūsų paramą."
  },
  Reschedule: {
    eng: "Reschedule",
    lt: "Perkelti"
  },
  "What’s included?": {
    eng: "What’s included?",
    lt: "Kas įskaičiuota?"
  },
  "Choose the gift card’s value": {
    eng: "Choose the gift card’s value",
    lt: "Pasirinkite dovanų čekio vertę"
  },
  "What areas shall we clean?": {
    eng: "What areas shall we clean?",
    lt: "Kurias vietas valysime?"
  },
  "Can't find available time or need help?": {
    eng: "Can't find available time or need help?",
    lt: "Nerandate norimo laiko arba reikia pagalbos?"
  },
  "Give us a call: {{number}}": {
    eng: "Give us a call: {{number}}",
    lt: "Skambtelėkite mums {{number}}"
  },
  help_num: {
    eng: "+353 1699 4255",
    lt: "+370 617 27375"
  },
  "How likely is that you'll book with us?": {
    eng: "How likely is that you'll book with us?",
    lt: "Kiek tikėtina, kad užsisakysite CleanBee paslaugas?"
  },
  "Not at all likely": {
    eng: "Not at all likely",
    lt: "neužsisakysiu niekada"
  },
  "Extremely likely": {
    eng: "Extremely likely",
    lt: "planuoju užsisakyti jau netrukus, baigiu išsirinkti"
  },
  "How reliable do you find us?": {
    eng: "How reliable do you find us?",
    lt: "Ar pasitikite CleanBee ir jos valytojais?"
  },
  "Extremely unreliable. I don't trust them": {
    eng: "Extremely unreliable. I don't trust them",
    lt: "visiškai nepasitikiu, neįsileisčiau į namus"
  },
  "Extremely reliable": {
    eng: "Extremely reliable",
    lt: "esu ramus ir nė kiek nesibaiminu"
  },
  "Why? (Optional)": {
    eng: "Why? (Optional)",
    lt: "Kodėl? (Neprivaloma)"
  },
  Submit: {
    eng: "Submit",
    lt: "Pateikti"
  },
  "Your booking would take longer than any business day of our cleaners. Please remove some services and check the calendar again.":
    {
      eng: "Your booking would take longer than any business day of our cleaners. Please remove some services and check the calendar again.",
      lt: "Jūsų užsakymas truktų ilgiau nei bet kuri mūsų valytojų darbo diena. Pašalinkite kai kurias paslaugas iš krepšelio ir patikrinkite kalendorių dar kartą."
    },
  "Coupon quota has been reached": {
    eng: "Coupon quota has been reached",
    lt: "Kuponas jau panaudotas maksimalų kiekį kartų"
  },
  "Coupon has expired": {
    eng: "Coupon has expired",
    lt: "Kuponas nebegalioja"
  },
  "Coupon hasn't covered selected services": {
    eng: "Coupon hasn't covered selected services",
    lt: "Kuponas pasirinktoms paslaugoms negalioja"
  },
  "This coupon doesn’t exist": {
    eng: "This coupon doesn’t exist",
    lt: "Toks kuponas neegzistuoja"
  },
  "Applied successfully": {
    eng: "Applied successfully",
    lt: "Pritaikyta"
  },
  Purchase: {
    eng: "Purchase",
    lt: "Įsigyti"
  }
};
